import {
  PageHeader,
  Tabs,
  Tag,
  Table,
  Select,
  Tooltip,
  Button,
  Radio,
  Row,
  Col,
} from "antd";
import Column from "antd/lib/table/Column";
import React, { Component } from "react";

import "../shared/css/list-page.css";
import "../shared/css/headerpages.css";
import { getTableService } from "../services/table-helper.service";
import Dialog from "../shared/dialog";

import { BrowserRouter as Router, Link, Switch } from "react-router-dom";
import ReactToPrint from "react-to-print";

const { Option } = Select;

const getRowKey = (record) => {
  return `${record.EmpId}`;
};
class SecondTabScreen extends Component {
  constructor(propsName) {
    super(propsName);
    this.inputRef = React.createRef();

    this.state = {
      language: localStorage.getItem("Language"),
      EmpListDatasource: [],
      SectorListDatasource: [],
      Columns: [],
      ColumnsDatasourceTH: [],
      ColumnsDatasourceEN: [],
      PositionList: [],
      SectorList: [],
      query: "",
      results: [],
      resultsAnsList: [],
      selectedRowKeys: null,
      visible: false,
      triggprint: true,
      ansDefault: [],
      evalStatus: "",

      five: [],
      four: [],
      three: [],
      two: [],
      one: [],
      //RUN 05/06/2021 เพิ่ม total เพื่อนำไปใช้ในการหา Percentage
      total: 0,
      //sector name for report
      sectorTH: "",
      sectorEN: "",
    };

    this.AnsData = {
      assessor: localStorage.getItem("EmpId"),
      ansForm: [],
    };

    console.log("this.props in second tab", this.props.propsName);
    this.dialog = new Dialog();
  }

  componentWillReceiveProps(nextProps) {
    console.log("nextProps", nextProps.propsName.lang);
    this.setState({ language: nextProps.propsName.lang });
    localStorage.setItem("Language", nextProps.propsName.lang);
  }

  componentDidMount() {
    console.log("componentRef", this.inputRef);

    //fetch ans list
    fetch(process.env.REACT_APP_API_URL + "/api/getAnsFirstLevel", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        AssessorId: localStorage.getItem("EmpId"),
        //AssessorId: 800
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("result getAnsFirstLevel", result);

        result.forEach((element) => {
          this.state.ansDefault = element.AnsForm;
        });

        //RUN: นำ ans data เข้าไปใส่ใน array ที่ใช้ ิวิ่งข้อมูล Default
        if (this.state.ansDefault.length > 0) {
          this.state.ansDefault.forEach((e) => {
            this.AnsData.ansForm.push({
              empid: e.EmpId,
              assessor: e.Assessor,
              Point: e.Point,
            });
          });
        }

        this.setState({
          ansDefault: this.state.ansDefault,
          evalStatus: result[0].EvaluteStatus,
        });
        console.log("this.state.ansDefault", this.state.ansDefault);
        console.log("evalStatus", this.state.evalStatus);

        var five = this.AnsData.ansForm.filter((e) => e.Point == 5);

        var four = this.AnsData.ansForm.filter((e) => e.Point == 4);
        var three = this.AnsData.ansForm.filter((e) => e.Point == 3);
        var two = this.AnsData.ansForm.filter((e) => e.Point == 2);
        var one = this.AnsData.ansForm.filter((e) => e.Point == 1);

        this.setState({
          five: five,
          four: four,
          three: three,
          two: two,
          one: one,
        });
      });

    //fetch emp list
    fetch(process.env.REACT_APP_API_URL + "/api/getUnderPrimaryByAdminId", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        empid: localStorage.getItem("EmpId"),
        //empid: 800
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("result here ", result);
        result.forEach((element) => {
          this.state.EmpListDatasource = element.EmpList;
          this.state.SectorListDatasource = element.SectorList;
          this.state.results = element.EmpList;
          //RUN 05/06/2021 เพิ่ม total เพื่อนำไปใช้ในการหา Percentage
          this.state.total = this.state.EmpListDatasource.length
        });
        this.state.EmpListDatasource.forEach((e) => {
          if (this.state.PositionList.length == 0) {
            this.state.PositionList.push({
              PositionNameTH: e.PositionNameTH,
              PositionNameEN: e.PositionNameEN,
            });
          } else {
            this.state.PositionList = this.positionPopper(e.PositionNameTH);
            this.state.PositionList.push({
              PositionNameTH: e.PositionNameTH,
              PositionNameEN: e.PositionNameEN,
            });
          }
          // console.log("EmpListDatasource", e.PositionNameTH);
        });
        this.setState({
          EmpListDatasource: this.state.EmpListDatasource,
          results: this.state.results,
          SectorListDatasource: this.state.SectorListDatasource,
          PositionList: this.state.PositionList,
        });
        console.log(
          "this.state.ColumnsDatasourceTH in second tab",
          this.state.ColumnsDatasourceTH
        );
        // console.log(
        //   "this.state.SectorListDatasource",
        //   this.state.SectorListDatasource
        // );
        // console.log("this.state.PositionList", this.state.PositionList);

        // console.log("this.state.EmpListDatasource bf sort", this.state.EmpListDatasource);
        this.state.EmpListDatasource.sort(function (a, b) {
          return a.EmpId - b.EmpId;
        });
        this.setState({
          EmpListDatasource: this.state.EmpListDatasource,
        });

        // console.log("this.state.EmpListDatasource after sort", this.state.EmpListDatasource);
      });

    // get data column
    getTableService("step-two").then((result) => {
      var table = [];
      result.forEach((e) => {
        this.state.Columns = e.TableColumn;
      });
      // console.log("this.state.Columns", this.state.Columns);

      // render thai
      this.state.Columns.forEach((e) => {
        // console.log("ColumnKeyTH", e.ColumnKeyTH);
        if (
          e.ColumnKeyTH !== "StepPoint" &&
          e.ColumnKeyTH !== "SumSelfCalPoint" &&
          e.ColumnKeyTH !== "SumAssessorCalPoint" &&
          e.ColumnKeyTH !== "EmpId"
        ) {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
          });
        } else if (e.ColumnKeyTH == "EmpId") {
          console.log("in empid");
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            defaultSortOrder: "descend",
            sorter: (a, b) => a.EmpId - b.EmpId,
            sortDirections: ["descend", "ascend"],
          });
        } else if (e.ColumnKeyTH == "SumSelfCalPoint") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (record.EvaluateStatus == 1) {
                return (
                  <div>
                    <p> ยังไม่ได้ประเมินตนเอง </p>
                  </div>
                );
              } else if (record.EvaluateStatus == 2) {
                return (
                  <div>
                    <p> กำลังประเมินตนเอง </p>
                  </div>
                );
              } else {
                return (
                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          });
        } else if (e.ColumnKeyTH == "SumAssessorCalPoint") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (e == null) {
                console.log("e in PrimaryEvaluteStatus", e);
                console.log("record in PrimaryEvaluteStatus", record);
                return (
                  <div>
                    <p> ยังไม่ได้ประเมินผู้ใต้สังกัด </p>
                  </div>
                );
              } else {
                return (
                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          });
        } else if (e.ColumnKeyTH == "StepPoint") {
          var estatus = [];
          this.state.ansDefault.forEach((e) => {
            return e.EvaluateStatus;
          });

          console.log("estatus", estatus);

          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (this.state.evalStatus == "2") {
                console.log(
                  "getDefaultScore in step point 2",
                  this.getDefaultScore(record.EmpId, this.AnsData.assessor)
                );
                // console.log('record.EvaluateStatus',  record.EvaluateStatus)
                return (
                  <div>
                    <p>
                      {this.getDefaultScore(
                        record.EmpId,
                        this.AnsData.assessor
                      )}
                    </p>
                  </div>
                );
              } else {
                // console.log(' in step point 1')
                return (
                  <div
                  onChange={(e) => {
                    this.handleChange(
                      record.EmpId,
                      this.AnsData.assessor,
                      e.target.value
                    );
                  }}
                  >

                    <Radio.Group
                      name="step-point"
                      buttonStyle="solid"
                      defaultValue={this.getDefaultScore(
                        record.EmpId,
                        this.AnsData.assessor
                      )}
                    >
                      <Radio.Button value={5}>5</Radio.Button>
                      <Radio.Button value={4}>4</Radio.Button>
                      <Radio.Button value={3}>3</Radio.Button>
                      <Radio.Button value={2}>2</Radio.Button>
                      <Radio.Button value={1}>1</Radio.Button>
                    </Radio.Group>
                  </div>
                );
              }
            },
          });
        }
      });

      this.setState({
        ColumnsDatasourceTH: this.state.ColumnsDatasourceTH.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });

      //render en
      this.state.Columns.forEach((e) => {
        // console.log("ColumnKeyEN", e.ColumnKeyEN);
        if (
          e.ColumnKeyEN !== "StepPoint" &&
          e.ColumnKeyEN !== "SumSelfCalPoint" &&
          e.ColumnKeyEN !== "SumAssessorCalPoint" &&
          e.ColumnKeyEN !== "EmpId"
        ) {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
          });
        } else if (e.ColumnKeyEN == "EmpId") {
          console.log("in empid");
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
            defaultSortOrder: "descend",
            sorter: (a, b) => a.EmpId - b.EmpId,
            sortDirections: ["descend", "ascend"],
          });
        } else if (e.ColumnKeyEN == "SumSelfCalPoint") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (record.EvaluateStatus == 1) {
                return (
                  <div>
                    <p> No Record </p>
                  </div>
                );
              } else if (record.EvaluateStatus == 2) {
                return (
                  <div>
                    <p> In progress </p>
                  </div>
                );
              } else {
                return (
                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          });
        } else if (e.ColumnKeyEN == "SumAssessorCalPoint") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (e == null) {
                return (
                  <div>
                    <p> No record </p>
                  </div>
                );
              } else {
                return (
                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          });
        } else if (e.ColumnKeyEN == "StepPoint") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (this.state.evalStatus == 2) {
                return (
                  <div>
                    {this.getDefaultScore(record.EmpId, this.AnsData.assessor)}
                  </div>
                );
              } else {
                return (
                  <div
                  onChange={(e) => {
                    this.handleChange(
                      record.EmpId,
                      this.AnsData.assessor,
                      e.target.value
                    );
                  }}
                  >
                    {/* <div>Avalaible on 25/04/2022</div> */}

                    <Radio.Group
                      name="step-point"
                      buttonStyle="solid"
                      defaultValue={this.getDefaultScore(
                        record.EmpId,
                        this.AnsData.assessor
                      )}
                    >
                      <Radio.Button value={5}>5</Radio.Button>
                      <Radio.Button value={4}>4</Radio.Button>
                      <Radio.Button value={3}>3</Radio.Button>
                      <Radio.Button value={2}>2</Radio.Button>
                      <Radio.Button value={1}>1</Radio.Button>
                    </Radio.Group>
                  </div>
                );
              }
            },
          });
        }
      });

      this.setState({
        ColumnsDatasourceEN: this.state.ColumnsDatasourceEN.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });
    });
  }

  testarrayDupFunction(empid, assessor) {
    console.log("testarrayDupFunction");
    var tempDup = [];
    //RUN: ยัดใส่เป็น ToString ให้หมดเนื่องจากส่งไปsave กับ ส่งคืนมา มีค่าdatatype อิอัยยยยยยยยยย 16/04/2021
    var tempempid = empid.toString();
    var tempassessor = assessor.toString();

    tempDup = this.AnsData.ansForm.filter((e) => {
      return e.empid !== empid || e.assessor !== assessor;
    });
    console.log("tempDup", tempDup);
    return tempDup;
  }

  positionPopper(sectorName) {
    var tempDup = [];
    tempDup = this.state.SectorListDatasource.filter((e) => {
      return sectorName !== e.SectorId;
    });
    return tempDup;
  }

  getDefaultScore(empid, assessor) {
    var tempArray = [];
    tempArray = this.state.ansDefault.filter((e) => {
      return e.EmpId == empid && e.Assessor == assessor;
    });

    if (tempArray.length > 0) {
      return tempArray[0].Point;
    } else {
      return null;
    }
  }

  getSearchResults = (query) => {
    const allData = this.state.results;
    const dataToShow = [];
    allData.forEach((item) => {
      console.log("item", item);
      const searchString = query;
      if (item.SectorId == searchString) {
        dataToShow.push(item);
      }
    });
    console.log("data to show: ", dataToShow);
    this.setState({
      EmpListDatasource: dataToShow,
    });
  };

  handleSectorChange = (value) => {
    console.log("handlePositionChange", value);
    this.setState(
      {
        query: value,
      },
      () => {
        if (this.state.query && this.state.query.length > 0) {
          console.log("this.state.query", this.state.query);
          this.getSearchResults(this.state.query);
          this.setState({ sectorTH: this.state.query });
        } else {
          this.setState({
            EmpListDatasource: this.state.results,
          });
        }
      }
    );
  };

  handleSaveDraft = (ansSaveData) => {
    var empid;
    var assess;
    var point;

    ansSaveData.forEach((element) => {
      empid = element.empid;
      assess = element.assessor;
      point = element.Point;
    });

    console.log("empid", empid);
    console.log("assess", assess);
    console.log("point", point);

    console.log("ansSaveData", ansSaveData);

    fetch(process.env.REACT_APP_API_URL + "/api/saveFormFirstLevel", {
      method: "post",

      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      body: JSON.stringify({
        empid: empid,
        formid: "1",
        assessor: assess,
        buttonaction: "1",
        jsonans: ansSaveData,
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("save draft result: " + JSON.stringify(result));
        if (result.status == "404") {
          // alert("บันทึกไม่สำเร็จ");
          //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021

          if (this.state.language == "TH") {
            this.dialog.WarningDialog("บันทึกร่างไม่สำเร็จ");
          } else {
            this.dialog.WarningDialog("Unable to Save Draft");
          }
        } else {
          if (this.state.language == "TH") {
            this.dialog.SuccessDialog(
              "บันทึกร่างสำเร็จ",
              "/assessing-subordinate"
            );
            localStorage.setItem("defaultActiveKey", 2);
          } else {
            this.dialog.SuccessDialog(
              "Save Draft Success",
              "/assessing-subordinate"
            );
            localStorage.setItem("defaultActiveKey", 2);
          }
        }
      });
  };

  handleSubmit = (ansSaveData, EmpListDatasource) => {
    //RUN: ตรวจสอบ condition ว่ามีค่าจำนวน ans เท่ากับ form หรือไม่ 11/04/2012
    var tempArray = [];
    var tempArrayRemarkvalidation = [];

    console.log("tempArrayRemarkvalidation", tempArrayRemarkvalidation);
    console.log("ansform", ansSaveData);

    console.log("ansSaveData.length", ansSaveData.length);
    console.log("EmpListDatasource.length", EmpListDatasource.length);

    //RUN: ใช้ Condition Nested If ให้เข้า Condition ให้ถูกต้อง และ แสดง error ขึ้นมาตามลำดับ 11/04/2021
    if (ansSaveData.length == EmpListDatasource.length) {
      if (tempArrayRemarkvalidation.length == 0) {
        fetch(process.env.REACT_APP_API_URL + "/api/saveFormFirstLevel", {
          method: "post",

          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },

          body: JSON.stringify({
            empid: localStorage.getItem("EmpId"),
            formid: "1",
            assessor: localStorage.getItem("EmpId"),
            buttonaction: "2",
            jsonans: ansSaveData,
          }),
        })
          .then((Response) => Response.json())
          .then((result) => {
            console.log("submit result: " + JSON.stringify(result));
            if (result.status == "404") {
              // alert("บันทึกไม่สำเร็จ");
              //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021

              if (this.state.language == "TH") {
                this.dialog.WarningDialog("บันทึกไม่สำเร็จ");
              } else {
                this.dialog.WarningDialog("Unable to Save");
              }
            } else {
              // alert("บันทึกสำเร็จ");
              // window.location.href = "/workform";
              //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021

              if (this.state.language == "TH") {
                this.dialog.SuccessDialog(
                  "บันทึกสำเร็จ",
                  "/assessing-subordinate"
                );
                localStorage.setItem("defaultActiveKey", 2);
              } else {
                this.dialog.SuccessDialog(
                  "Save Success",
                  "/assessing-subordinate"
                );
                localStorage.setItem("defaultActiveKey", 2);
              }
            }
          });
      } else {
        // alert(
        //   "บันทึกไม่สำเร็จ ข้อมูลเหตุผลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน"
        // );
        //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021
        if (this.state.language == "TH") {
          this.dialog.WarningDialog(
            "บันทึกไม่สำเร็จ ข้อมูลเหตุผลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน"
          );
        } else {
          this.dialog.WarningDialog(
            "Unable to save due to incomplete remark. Please check your assessment informations."
          );
        }
      }
    } else {
      // alert("บันทึกไม่สำเร็จ ข้อมูลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน");
      //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021

      if (this.state.language == "TH") {
        this.dialog.WarningDialog(
          "บันทึกไม่สำเร็จ ข้อมูลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน"
        );
      } else {
        this.dialog.WarningDialog(
          "Unable to save due to incomplete data. Please check your assessment informations."
        );
      }
    }
  };

  handleChange = (empid, assessor, value) => {
    console.log("in change");

    var temp = [];
    temp = this.AnsData.ansForm.filter((e) => {
      return e.empid == empid && e.assessor == assessor;
    });

    if (temp.length == 0) {
      this.AnsData.ansForm.push({
        empid: empid,
        assessor: assessor,
        Point: value,
      });
    } else {
      this.AnsData.ansForm = this.testarrayDupFunction(empid, assessor);

      this.AnsData.ansForm.push({
        empid: empid,
        assessor: assessor,
        Point: value,
      });
    }

    console.log("ansForm", this.AnsData.ansForm);

    var five = this.AnsData.ansForm.filter((e) => e.Point == 5);

    var four = this.AnsData.ansForm.filter((e) => e.Point == 4);
    var three = this.AnsData.ansForm.filter((e) => e.Point == 3);
    var two = this.AnsData.ansForm.filter((e) => e.Point == 2);
    var one = this.AnsData.ansForm.filter((e) => e.Point == 1);

    this.setState({ five: five, four: four, three: three, two: two, one: one });
    console.log("this.state.ansDefault in count", this.state.ansDefault);
    console.log("five", this.state.five);
    console.log("four", this.state.four.length);
    console.log("three", this.state.three.length);
    console.log("two", this.state.two.length);
    console.log("one", this.state.one.length);
  };

  setRowKey(record) {
    const selectedRowKey = getRowKey(record);
    console.log(selectedRowKey, typeof selectedRowKey);
    this.setState({ selectedRowKey });
  }

  renderContentTH() {
    const {
      EmpListDatasource,
      ColumnsDatasourceTH,
      PositionList,
      SectorListDatasource,
    } = this.state;

    console.log("this.state.sectorTH", this.state.sectorTH);

    var tempSector = SectorListDatasource.filter((e) => {
      return e.SectorId == this.state.sectorTH;
    });

    console.log("tempSector", tempSector);

    return (
      <div style={{ padding: 15 }}>
        <Row>
          {/* render Left section */}
          <Col span={12}>
            <label style={{ paddingRight: 15 }}>เลือกตามสังกัด:</label>
            <Select
              placeholder="ทั้งหมด"
              bordered

              defaultValue={"ทั้งหมด"}
              onChange={(e) => this.handleSectorChange(e)}
              style={{ width: '25em', textAlign: 'center' }}

            >
              <Option value={null}
                style={{ textAlign: 'center' }}
              > ทั้งหมด </Option>
              {SectorListDatasource.map((position) => (
                <Option value={position.SectorId}
                  style={{ textAlign: 'center' }}
                >
                  {position.SectorNameTH}
                </Option>
              ))}
            </Select>

            {/* render Right sector */}
            <div>
              <label style={{ paddingRight: 15 }}>
                <b> จำนวนบุคลากรในสังกัด </b> {EmpListDatasource.length} คน
              </label>
            </div>
          </Col>

          <Col span={12}>{this.renderCountTH()}</Col>
        </Row>

        <div className="tab-centered">
          <Table
            dataSource={EmpListDatasource}
            columns={ColumnsDatasourceTH}
            rowKey={(record) => getRowKey(record)}
            rowClassName={(record) =>
              getRowKey(record) === this.state.selectedRowKey
                ? "highlighted-selection"
                : ""
            }
            onRow={(record) => {
              return {
                onClick: () => {
                  this.setState({ visible: true });
                  this.setRowKey(record);
                },
              };
            }}
            pagination={false}
          >
            <Column />
          </Table>
        </div>

        {this.state.evalStatus == "2" ? (
          <div>
            <ReactToPrint
              trigger={() => {
                return (
                  <div
                    style={{
                      textAlign: "center",
                      margin: "auto",
                      marginBlock: 15,
                    }}
                  >
                    <Button type="primary">พิมพ์รายงาน</Button>
                  </div>
                );
              }}
              content={() => this.componentRef}
            />
            <div style={{ display: "none" }}>
              {/* to print component */}
              <div ref={(el) => (this.componentRef = el)}>
                <div style={{ textAlign: "center" }}>
                  <h3>
                    รายงานพิจารณาระดับผลการปฏิบัติงานบุคลากร ประจำปีการศึกษา
                    2564
                  </h3>
                  <h3> {tempSector.map((e) => e.SectorNameTH)}</h3>
                </div>

                <Row>
                  {/* render Left section */}
                  <Col span={12}>
                    <div>
                      <label style={{ paddingRight: 15 }}>
                        <b> จำนวนบุคลากรในสังกัด </b> {EmpListDatasource.length}
                        คน
                      </label>
                    </div>
                  </Col>

                  {/* render Right sector */}
                  <Col span={12}>{this.renderCountTH()}</Col>
                </Row>

                <div>
                  <Table
                    dataSource={EmpListDatasource}
                    columns={ColumnsDatasourceTH}
                    rowKey={(record) => getRowKey(record)}
                    rowClassName={(record) =>
                      getRowKey(record) === this.state.selectedRowKey
                        ? "highlighted-selection"
                        : ""
                    }
                    onRow={(record) => {
                      return {
                        onClick: () => {
                          this.setState({ visible: true });
                          this.setRowKey(record);
                        },
                      };
                    }}
                    pagination={false}
                  >
                    <Column />
                  </Table>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ textAlign: "center", marginTop: 25 }}>
                    <p> ลงชื่อ _________________________________</p>
                    <p>
                      {" "}
                      {"( " +
                        localStorage.getItem("TitleTH") +
                        " " +
                        localStorage.getItem("FirstNameTH") +
                        " " +
                        localStorage.getItem("LastNameTH") +
                        " )"}
                    </p>
                    <p> ตำแหน่ง _______________________________</p>
                    <p> วันที่ _________________</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        ) : (
          <div style={{ textAlign: "center", marginTop: 15, marginBottom: 15 }}>
            <Button
              onClick={(e) => {
                this.handleSaveDraft(this.AnsData.ansForm);
              }}
            >
              บันทึกร่าง
            </Button>

            <Button
              type="primary"
              onClick={(e) => {
                this.handleSubmit(
                  this.AnsData.ansForm,
                  this.state.EmpListDatasource
                );
              }}
            >
              ส่งข้อมูล
            </Button>
          </div>
        )}
      </div>
    );
  }

  renderContentEN() {
    const { EmpListDatasource, ColumnsDatasourceEN, SectorListDatasource } =
      this.state;

    var tempSector = SectorListDatasource.filter((e) => {
      return e.SectorId == this.state.sectorTH;
    });

    console.log("tempSector", tempSector);

    return (
      <div style={{ padding: 15 }}>
        <Row>
          {/* render Left section */}
          <Col span={12}>
            <label style={{ paddingRight: 15 }}>Choose by Sector:</label>
            <Select
              placeholder="All"
              bordered

              defaultValue={"All"}
              onChange={(e) => this.handleSectorChange(e)}
              style={{ width: '25em', textAlign: 'center' }}
            >
              <Option value={null}
                style={{ textAlign: 'center' }}
              > All </Option>
              {SectorListDatasource.map((position) => (
                <Option value={position.SectorId}
                  style={{ textAlign: 'center' }}
                >
                  {position.SectorNameTH}
                </Option>
              ))}
            </Select>

            {/* render Right sector */}
            <div>
              <label style={{ paddingRight: 15 }}>
                <b> Total </b> {EmpListDatasource.length}
              </label>
            </div>
          </Col>

          <Col span={12}>{this.renderCountEN()}</Col>
        </Row>

        <div className="tab-centered">
          <Table
            dataSource={EmpListDatasource}
            columns={ColumnsDatasourceEN}
            rowKey={(record) => getRowKey(record)}
            rowClassName={(record) =>
              getRowKey(record) === this.state.selectedRowKey
                ? "highlighted-selection"
                : ""
            }
            onRow={(record) => {
              return {
                onClick: () => {
                  this.setState({ visible: true });
                  this.setRowKey(record);
                },
              };
            }}
            pagination={false}
          >
            <Column></Column>
          </Table>
        </div>

        {this.state.evalStatus == "2" ? (
          <div>
            <ReactToPrint
              trigger={() => {
                return (
                  <div
                    style={{
                      textAlign: "center",
                      margin: "auto",
                      marginBlock: 15,
                    }}
                  >
                    <Button hidden type="primary">Print Report</Button>
                  </div>
                );
              }}
              content={() => this.componentRef}
            />
            <div style={{ display: "none" }}>
              {/* to print component */}
              <div ref={(el) => (this.componentRef = el)}>
                <div style={{ textAlign: "center" }}>
                  <h3>
                    {" "}
                    Report of level on work Performance for acadamic year 2020
                  </h3>
                  <h3> {tempSector.map((e) => e.SectorNameEN)}</h3>
                </div>

                <Row>
                  {/* render Left section */}
                  <Col span={12}>
                    <div>
                      <label style={{ paddingRight: 15 }}>
                        <b> จำนวนบุคลากรในสังกัด </b> {EmpListDatasource.length}{" "}
                        คน
                      </label>
                    </div>
                  </Col>

                  {/* render Right sector */}
                  <Col span={12}>{this.renderCountEN()}</Col>
                </Row>

                <div>
                  <Table
                    dataSource={EmpListDatasource}
                    columns={ColumnsDatasourceEN}
                    rowKey={(record) => getRowKey(record)}
                    rowClassName={(record) =>
                      getRowKey(record) === this.state.selectedRowKey
                        ? "highlighted-selection"
                        : ""
                    }
                    onRow={(record) => {
                      return {
                        onClick: () => {
                          this.setState({ visible: true });
                          this.setRowKey(record);
                        },
                      };
                    }}
                    pagination={false}
                  >
                    <Column />
                  </Table>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ textAlign: "center", marginTop: 25 }}>
                    <p> Signature _________________________________</p>
                    <p>
                      {"( " +
                        localStorage.getItem("TitleEN") +
                        " " +
                        localStorage.getItem("FirstNameEN") +
                        " " +
                        localStorage.getItem("LastNameEN") +
                        " )"}
                    </p>
                    <p> Position _______________________________</p>
                    <p> Date _________________</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        ) : (
          <div style={{ textAlign: "center", marginTop: 15, marginBottom: 15 }}>
            <Button
              onClick={(e) => {
                this.handleSaveDraft(this.AnsData.ansForm);
              }}
            >
              Draft
            </Button>

            <Button
              type="primary"
              onClick={(e) => {
                this.handleSubmit(
                  this.AnsData.ansForm,
                  this.state.EmpListDatasource
                );
              }}
            >
              Submit
            </Button>
          </div>
        )}
      </div>
    );
  }

  renderCountTH() {
    {/* RUN 05/06/2021 นำ percentage ไปใส่ */ }

    const { five, four, three, two, one, total } = this.state;

    return (
      <div style={{ textAlign: "right" }}>
        <h4>
          {" "}
          <b>ระดับผลปฎิบัติงาน </b> <br />

          5: {five.length} คน ({(five.length / total * 100).toFixed(2)}%) | 4: {four.length} คน ({(four.length / total * 100).toFixed(2)}%) | 3: {three.length} คน ({(three.length / total * 100).toFixed(2)}%)  | 2:{" "}
          {two.length} คน ({(two.length / total * 100).toFixed(2)}%)  | 1: {one.length} คน ({(one.length / total * 100).toFixed(2)}%)  {" "}
        </h4>
      </div>
    );
  }

  renderCountEN() {
    {/* RUN 05/06/2021 นำ percentage ไปใส่ */ }

    const { five, four, three, two, one, total } = this.state;

    return (
      <div style={{ textAlign: "right" }}>
        <h4>
          {" "}
          <b>Result of Work Performance </b> <br />
          5: {five.length} ({(five.length / total * 100).toFixed(2)}%)  | 4: {four.length} ({(four.length / total * 100).toFixed(2)}%)  | 3: {three.length} ({(three.length / total * 100).toFixed(2)}%)  | 2:{" "}
          {two.length} ({(two.length / total * 100).toFixed(2)}%)  | 1: {one.length} ({(one.length / total * 100).toFixed(2)}%) {" "}
        </h4>
      </div>
    );
  }

  render() {
    console.log("this.state.evalstatus", this.state.evalStatus);

    return (
      <div>
        {this.state.language == "TH"
          ? this.renderContentTH()
          : this.renderContentEN()}
      </div>
    );
  }
}

export default SecondTabScreen;
